// extracted by mini-css-extract-plugin
export default {"table":"StyledTable_table__vqHuK","tableHeader":"StyledTable_tableHeader__EjzRd"};